import Link from "next/link";
import { storyblokEditable } from "@storyblok/react/rsc";

import { Button } from "@/components/ui/button";
import { ArrowRight } from "@/components/icons/ArrowRight";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
} from "@/components/ui/card";
import { Headline } from "@/components/typography/Headline";
import { CopyText } from "@/components/typography/CopyText";
import { Icon } from "@/components/typography/Icon";
import type { IconName } from "@/components/typography/Icon";
import type { FeatureItemStoryblok } from "@/component-types-sb";
import { getUrlFromLinkObject } from "@/lib/storyblok/utils";

type FeatureItemProps = {
  blok: FeatureItemStoryblok;
  variant?: "list" | "card";
};

const FeatureItem = ({ blok, variant = "card" }: FeatureItemProps) => {
  return (
    <>
      {variant === "card" && (
        <Card {...storyblokEditable(blok)} className="rounded-2xl border-none text-black-95">
          <CardHeader>
            <Icon name={blok.icon as IconName} className="w-12 h-12" />
          </CardHeader>
          <CardContent>
            {blok.headline && (
              <Headline as="h5" size="regular" className="block">
                {blok.headline}
              </Headline>
            )}
            <CopyText>{blok.text}</CopyText>
          </CardContent>
          <CardFooter>
            <Link href={getUrlFromLinkObject(blok?.cta?.[0]?.link) || "#"} className="min-w-0 max-w-full">
              <Button variant="white" size="sm">
                {blok?.cta?.[0]?.label}
                <ArrowRight size="sm" />
              </Button>
            </Link>
          </CardFooter>
        </Card>
      )}

      {variant === "list" && (
        <li {...storyblokEditable(blok)} className="text-black-95">
          <Icon name={blok.icon as IconName} className="w-12 h-12 mb-6" />
          {blok.headline && (
            <Headline as="h3" size="regular" className="block">
              {blok.headline}
            </Headline>
          )}
          <CopyText>{blok.text}</CopyText>
        </li>
      )}
    </>
  );
};

export default FeatureItem;
